import axios from "../../axios";

export function panics_getHistory(skip, limit) {
    return (async (dispatch) => {
        try {
            let response = await axios.get(`Panics/history`,
                {
                    params: {
                        skip: skip,
                        limit: limit
                    }
                }
            );
            dispatch({
                type: "PANICS_HISTORY_FULFILLED",
                payload: {
                    data: response.data,
                    error: null
                }
            });
        }
        catch (e) {
            dispatch({
                type: "PANICS_HISTORY_REJECTED",
                payload: {
                    response: null,
                    error: e
                }
            });
        }
    });
}
export function panics_getTypeahead() {
    return (async (dispatch) => {
        try {
            let response = await axios.get(`Panics/typeahead`);
            dispatch({
                type: "PANICS_TYPEAHEAD_FULFILLED",
                payload: {
                    data: response.data,
                    error: null
                }
            });
        }
        catch (e) {
            dispatch({
                type: "PANICS_TYPEAHEAD_REJECTED",
                payload: {
                    response: null,
                    error: e
                }
            });
        }
    });
}
export function panics_onHistoryCurrentPage(index) {
    return (dispatch => {
        dispatch({
            type: "PANICS_HISTORY_CURRPAGE",
            payload: { index }
        });
    });
}
export function panics_onItemsPerPage(count) {
    return (dispatch => {
        dispatch({
            type: "PANICS_HISTORY_ITEMPERPAGE",
            payload: {
                count
            }
        });
    });
}
export function panics_onHistoryClear() {
    return (dispatch => {
        dispatch(
            {
                type: "PANICS_HISTORY_CLEAR",
                payload: null
            }
        );
    })
}
export function panics_getFilteredHistory(skip, limit, filter) {
    return (async (dispatch) => {
        try {
            let response = await axios.get(`Panics/filtered?skip=${skip}&limit=${limit}&filter=${encodeURIComponent(JSON.stringify(filter))}`);
            dispatch({
                type: "PANICS_FILTERED_HISTORY_FULFILLED",
                payload: {
                    data: response.data,
                    error: null
                }
            });
        }
        catch (e) {
            dispatch({
                type: "PANICS_FILTERED_HISTORY_REJECTED",
                payload: {
                    response: null,
                    error: e
                }
            });
        }
    });
}
export function panics_getLog(panicId) {
    return (async (dispatch) => {
        try {
            let response = await axios.get(`Panics/${panicId}?filter=${encodeURIComponent(JSON.stringify({
                where: {
                    remark: 'Resolved'
                },
                include: {
                    relation: "tracker",
                    scope: {
                        fields: ["id", "sessionId"],
                        include: [
                            {
                                relation: "session",
                                scope: {
                                    include: "patrollers"
                                }
                            },
                            {
                                relation: "routes",
                                scope: {
                                    order: "id ASC"
                                }
                            }
                        ]
                    }
                }
            }))}`);

            dispatch({
                type: "PANICS_LOG_FULFILLED",
                payload: {
                    data: response.data,
                    error: null
                }
            });
        }
        catch (e) {
            dispatch({
                type: "PANICS_LOG_REJECTED",
                payload: {
                    response: null,
                    error: e
                }
            });
        }
    });
}
export function panics_clrLog() {
    return (dispatch => {
        dispatch({
            type: "PANICS_LOG_CLEAR",
            payload: {
                data: null,
                error: null
            }
        });
    });
}


// WEBPACK FOOTER //
// ./src/redux/actions/panics.js